import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nextron-lang") || "en");
  const t = translations[lang] || translations.en;

  useEffect(() => {
    localStorage.setItem("nextron-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "hi" : "en"));

  return <LangContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
